import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m12.24 3.333-5.386-.446-2-.167V2a.667.667 0 0 0-1.333 0v12a.666.666 0 1 0 1.333 0V9.28l2-.167 5.387-.446A.667.667 0 0 0 12.854 8V4a.667.667 0 0 0-.613-.667m-6.052 4.5-1.334.107V4.06l1.334.107zm2.666-.226-1.333.113V4.28l1.333.113zm2.667-.22-1.334.113v-3l1.334.113z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })